import { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

export function IconLeadGen({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Funnel / magnet shape */}
      <path d="M3 4h18l-7 8v6l-4-2V12L3 4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.1"/>
      <circle cx="12" cy="19" r="1.5" fill="currentColor"/>
      <path d="M10 13l2 1.5 2-1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconContent({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Document with pen */}
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.1"/>
      <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M15.5 10.5l1 1-3 3H12v-1.5l3-3z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
    </svg>
  );
}

export function IconData({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Database cylinders */}
      <ellipse cx="12" cy="6" rx="8" ry="2.5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.1"/>
      <path d="M4 6v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5V6" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M4 10v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-4" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M4 14v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-4" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}

export function IconSocialMedia({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Network nodes */}
      <circle cx="5" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15"/>
      <circle cx="12" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15"/>
      <circle cx="19" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15"/>
      <circle cx="12" cy="19" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15"/>
      <circle cx="12" cy="12" r="2" fill="currentColor"/>
      <path d="M7.4 10.6l3.2-4M14.6 7.4l3 4M16.6 13.4l-3 4M9.4 16.6l-3-4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  );
}

export function IconCodeDev({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Terminal / code brackets */}
      <rect x="2" y="3" width="20" height="18" rx="3" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.08"/>
      <circle cx="6" cy="7.5" r="1" fill="currentColor" fillOpacity="0.6"/>
      <circle cx="9.5" cy="7.5" r="1" fill="currentColor" fillOpacity="0.6"/>
      <circle cx="13" cy="7.5" r="1" fill="currentColor" fillOpacity="0.6"/>
      <path d="M8 13l-3 2 3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 13l3 2-3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.5 11.5l-3 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconCustomerSupport({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Headset + chat bubble */}
      <path d="M12 3C7.58 3 4 6.58 4 11v3a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H6v-1a6 6 0 1 1 12 0v1h-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 0 2-2v-3c0-4.42-3.58-8-8-8z" fill="currentColor" fillOpacity="0.12" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 16v2a2 2 0 0 0 2 2h1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconResearch({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Magnifier over graph */}
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.08"/>
      <path d="M15.5 15.5l5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M7 12l2-3 2 2 2-4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconMarketing({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Megaphone / target */}
      <path d="M18 3l-6 4H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h7l6 4V3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.1"/>
      <path d="M9 13v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M21 9a4 4 0 0 1 0 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconTranslation({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Globe + language */}
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.08"/>
      <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" stroke="currentColor" strokeWidth="1.3"/>
    </svg>
  );
}

export function IconCustom({ size = 24, ...p }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...p}>
      {/* Sparkle / magic */}
      <path d="M12 2l1.8 5.4L19 9l-5.2 2.6L12 17l-1.8-5.4L5 9l5.2-1.6L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="currentColor" fillOpacity="0.12"/>
      <path d="M5 19l.9 2.7L8.6 23l-2.7.9L5 26" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="19" cy="4" r="1.5" fill="currentColor" fillOpacity="0.5"/>
    </svg>
  );
}

// Map from vertical key to icon component + display info
export const VERTICAL_META: Record<string, {
  label: string;
  Icon: (p: IconProps) => JSX.Element;
  color: string;         // tailwind text color class
  bg: string;            // tailwind bg class
}> = {
  LEAD_GEN:         { label: "Lead Generation",    Icon: IconLeadGen,        color: "text-orange-400",  bg: "bg-orange-500/10" },
  CONTENT:          { label: "Content Creation",   Icon: IconContent,        color: "text-violet-400",  bg: "bg-violet-500/10" },
  DATA:             { label: "Data Processing",    Icon: IconData,           color: "text-sky-400",     bg: "bg-sky-500/10" },
  SOCIAL_MEDIA:     { label: "Social Media",       Icon: IconSocialMedia,    color: "text-pink-400",    bg: "bg-pink-500/10" },
  CODE_DEV:         { label: "Code & Dev",         Icon: IconCodeDev,        color: "text-emerald-400", bg: "bg-emerald-500/10" },
  CUSTOMER_SUPPORT: { label: "Customer Support",   Icon: IconCustomerSupport,color: "text-yellow-400",  bg: "bg-yellow-500/10" },
  RESEARCH:         { label: "Research",           Icon: IconResearch,       color: "text-cyan-400",    bg: "bg-cyan-500/10" },
  MARKETING:        { label: "Marketing",          Icon: IconMarketing,      color: "text-red-400",     bg: "bg-red-500/10" },
  TRANSLATION:      { label: "Translation",        Icon: IconTranslation,    color: "text-teal-400",    bg: "bg-teal-500/10" },
  CUSTOM:           { label: "Custom",             Icon: IconCustom,         color: "text-primary",     bg: "bg-primary/10" },
};

export function getVerticalMeta(key: string) {
  return VERTICAL_META[key] ?? {
    label: key,
    Icon: IconCustom,
    color: "text-muted-foreground",
    bg: "bg-muted/30",
  };
}
